import React from 'react';
import { connect } from 'react-redux';
import UnlockPremium from './UnlockPremium'
import { Modal, Button as AButton } from 'antd';
import { CheckIcon } from '../core/icons'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'

import styled from 'styled-components'

import { push, goBack } from 'react-router-redux'
import New from '../account/favorite-places/New'
import Update from '../account/favorite-places/Update'


export const Button = styled(AButton).attrs({
  type: props => props.primary && 'primary'
})`
  font-size: 18px;
  margin-top: 12px;

  ${props=>props.fullWidth&&`
    width: 100%;
    height: 42px;
  `}
`

const Body = styled.div`
  padding: 5vmin;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: large;
  h1 {
    font-size: 25px;
    text-transform: capitalize;

  }
  ${'' /* > ol {
    list-style: decimal;
    padding-left: 30px;
    li {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 1vmin 0;
    }
  } */}
`

const getAddress = ({street, city, state, country}) => (street||'')+" "+city+" "+state+" "+country


const nameThisPlaceModal = ({ dispatch, message, title, buttonText, latLng, addr, place, shouldRename, place_type, trip_token_id, current_trips_loaded_count }) => (
  <Modal
    size='large'
    bodyStyle={{padding: 0}}
    visible={true}
    // width={'80vw'}
    // height={'80vw'}
    zIndex={1040}
    onOk={() => {
      // other action
      dispatch({type:'HIDE_MODAL_2'})
    }}
    onCancel={() => dispatch({type:'HIDE_MODAL_2'})}
    footer={null}
  >
    <Body>
      <h1>{title}</h1>
      <p>{message}</p>

      {shouldRename?
        <Update
          initialValues={{
            addedOnTripList: true,
            current_trips_loaded_count
          }}
          address={addr}
          placeId={place.token_id}
        />
        :
        <New
          initialValues={{
            icon_name: "Marker",
            // latitude: latLng.split(",")[0],
            // longitude:  latLng.split(",")[1],
            address: addr,
            trip_token_id,
            place_type,
            current_trips_loaded_count,
            addedOnTripList: true
          }}
          address={addr}
        />

      }

    </Body>
  </Modal>

)

export default connect(
  // ownProps in this case are modalProps passed from the action or reducer
  (state, ownProps) => ({
    current_trips_loaded_count: state.models.trips.length
  })
)(nameThisPlaceModal)



// WEBPACK FOOTER //
// ./src/modal/NameThisPlaceModal.js